/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SmileyBlank(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM92,120a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,92,120Zm72,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,164,120Z" />
    </Svg>
  );
}

export default SmileyBlank;
